import { Suspense } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@/auth/AuthContext";
import RouteError from "@/pages/RouteError";
import routes from "@/router/config";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

// 최상위 라우트마다 오류 화면을 달아 둔다. 없으면 react-router 의 영문 기본 오류 화면
// ("Hey developer …")이 그대로 사용자에게 보인다.
const router = createBrowserRouter(
  routes.map((route) => ({ errorElement: <RouteError />, ...route }))
);

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      {/* 인증 상태는 라우터보다 위에 둔다 — 라우트 가드가 컨텍스트를 읽어야 한다 */}
      <AuthProvider>
        <Suspense
          fallback={
            <div className="flex h-screen items-center justify-center text-sm text-gray-400">
              불러오는 중
            </div>
          }
        >
          <RouterProvider router={router} />
        </Suspense>
      </AuthProvider>
    </QueryClientProvider>
  );
}
